import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";

export type ZooplaAccessLevel = "none" | "light" | "full";

/**
 * Determines user's Zoopla access level based on their features
 * @returns 'full' for zooplaFullAccess, 'light' for zooplaLightAccess only, 'none' for no access
 */
export function getZooplaAccessLevel(): ZooplaAccessLevel {
  if (hasFeature(Feature.zooplaFullAccess)) {
    return "full";
  } else if (hasFeature(Feature.zooplaLightAccess)) {
    return "light";
  } else {
    return "none";
  }
}
